import TypeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';

import {
  GET_DEPRECIATIONS,
  SET_DEPRECIATIONS_PAGINATION,
  SET_DEPRECIATIONS_FILTERS,
  RESET_DEPRECIATIONS,
  TOGGLE_DEPRECIATION,
} from 'depreciations/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const depreciation = new schema.Entity('depreciations');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['key', 'name'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { depreciations: {} },
  result: { depreciations: [] },
};

export const getPending = (state) => ({ ...state, isLoading: true, needFetch: false });

export const getFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  pagination: {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  },
  ...normalize({ depreciations: payload.records }, { depreciations: [depreciation] }),
});

export const getRejected = (state) => ({ ...state, isLoading: false });

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const togglePending = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    depreciations: {
      ...state.entities.depreciations,
      [meta.id]: { ...state.entities.depreciations[meta.id], isLoading: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    depreciations: {
      ...state.entities.depreciations,
      [meta.id]: { ...state.entities.depreciations[meta.id], isLoading: false },
    },
  },
});

export const toggleFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    depreciations: {
      ...state.entities.depreciations,
      [payload.depreciation.id]: { ...payload.depreciation, isLoading: false },
    },
  },
});

const reducers = {
  [GET_DEPRECIATIONS]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [SET_DEPRECIATIONS_PAGINATION]: setPagination,
  [SET_DEPRECIATIONS_FILTERS]: setFilters,
  [RESET_DEPRECIATIONS]: reset,
  [TOGGLE_DEPRECIATION]: {
    [PENDING]: togglePending,
    [FULFILLED]: toggleFulfilled,
    [REJECTED]: toggleRejected,
  },
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/reducers/depreciations_list_reducers.js